import type { MouseEvent } from "react";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import type { Branch } from "../../providers/branchesProvider";
import { renderAddress } from "../../misc/AddressDisplay";
import { Column } from "../../misc/Column";
import { Row } from "../../misc/Row";

export function BranchMobileListItem(props: {
  branch: Branch;
  managerName?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { branch, managerName, onClick } = props;
  const theme = useTheme();
  const details = [
    branch.isDefaultBranch ? "Hauptfiliale" : undefined,
    `Max. Schüler Theorie: ${branch.maxStudentsForTheory}`,
  ].filter(Boolean);

  return (
    <ButtonBase
      component="div"
      data-testid="BranchMobileListItem"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Column sx={{ gap: 0.5, minWidth: 0 }}>
        <Row sx={{ alignItems: "flex-start", gap: 1.25, minWidth: 0 }}>
          <Box
            sx={{
              alignItems: "center",
              backgroundColor: theme.palette.action.hover,
              borderRadius: "50%",
              color: theme.palette.text.secondary,
              display: "flex",
              flexShrink: 0,
              height: 40,
              justifyContent: "center",
              width: 40,
            }}
          >
            <StorefrontOutlinedIcon fontSize="small" />
          </Box>
          <Column sx={{ gap: 0.25, minWidth: 0 }}>
            <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
              {branch.name}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
              {renderAddress(branch.address, { oneLine: true })}
            </Typography>
          </Column>
        </Row>
        <Typography variant="caption" color="text.secondary">
          {details.join(" · ")}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
          Standard-Fahrschulleiter: {managerName ?? "Nicht festgelegt"}
        </Typography>
      </Column>
    </ButtonBase>
  );
}
